{
  "gateway_server.asset_not_found": "Asset not found.",
  "gateway_server.verify_body": "Complete this quick check before continuing to sign up.",
  "gateway_server.verify_continue_action": "Continue",
  "gateway_server.verify_failed_error": "Verification failed.",
  "gateway_server.verify_failed_retry": "The verification check failed. Please try again.",
  "gateway_server.verify_heading": "Verify to continue",
  "gateway_server.verify_load_error": "The verification check could not load. Please try again.",
  "gateway_server.verify_missing_token_error": "Please complete the verification check.",
  "gateway_server.verify_page_title": "Verify | Tov+",
  "gateway_server.waitlist_body": "We are currently opening planner access in stages. Existing users can still sign in normally.",
  "gateway_server.waitlist_heading": "Join Tov+ through the waitlist.",
  "gateway_server.waitlist_page_title": "Waitlist | Tov+",
  "gateway_server.waitlist_primary_action": "Join the waitlist",
  "gateway_server.waitlist_secondary_action": "Return to sign in",
  "identity.service.text_unavailable": "Text unavailable."
}
